import { stickyComponent } from '../StickyComponent/index.js';

import styles from './CallsToAction.scss';
import { CallsToAction } from './CallsToAction';

function shouldStick(inView, stickyComponentContext) {
  return !inView && !stickyComponentContext?.footerVisible;
}

export const ProductHeroCTAs = stickyComponent(CallsToAction, {
  shouldStick,
  removalDelayMs: 500,
  stickyClassName: styles.stickyCtas,
  stickyUnmountingClassName: styles.stickyCtaIsUnmounting,
});
